import React, { useState, useEffect, useCallback } from 'react';

import {
  MdModeEdit,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdArrowDropUp,
} from 'react-icons/md';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { GoPlus } from 'react-icons/go';

import { Link } from 'react-router-dom';

import { Pagination } from 'antd';

import { ClipLoader } from 'react-spinners';

import { IoMdArrowBack } from 'react-icons/io';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '~/store/modules/instituitions/actions';

import { Breadcumbs } from '~/components/Breadcumbs';

import history from '~/services/history';

import { ButtonBase } from '~/components/Button';

import { ButtonOrderBy } from '~/components/ButtonOrderBy';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
} from './style';

import iconProfileInstitutions from '~/assets/icons/circle-profile-institutions.svg';
import iconCharts from '~/assets/icons/icon-charts.svg';
import VALIDATIONS from '~/helpers/validations';

const InstituicoesParticipantes = () => {
  const dispath = useDispatch();

  const { roles } = useSelector(state => state.auth);

  const {
    instituitionsData,
    instituitionsOrderBy,
    instituitionsSearch,
    loadingInstitutions: loading,
  } = useSelector(state => state.instituitions);

  const { data = [], totalCount = 0 } = instituitionsData;

  const [pageCurrent, setPageCurrent] = useState(1);
  const [limit] = useState(5);

  const searchStorage = sessionStorage.getItem('searchInstituition');

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  if (!ROLE_ADMIN) {
    history.push('/');
  }

  const [directionAsc, setDirectionAsc] = useState(true);

  const getAllInstitutions = useCallback(props => {
    const orderBy = props?.orderBy;
    const search = props?.search;
    const dir = props?.dir;
    const offset = props?.offset;


    if (orderBy) sessionStorage.setItem('orderBy', orderBy);

    // setPageCurrent(1);
    dispath(
      actions.getInstitutionsRequest({
        orderBy: orderBy || '',
        search: search || '',
        offset,
        direction: dir ? 'asc' : 'desc',
      })
    );

    if (!offset) {
      setPageCurrent(1);
    }
  }, []);

  const paginationChange = useCallback(
    async page => {
      const orderBy = sessionStorage.getItem('orderBy');

      setPageCurrent(page);

      const limitOffset = page - 1;
      const offset = page <= 1 ? 0 : limitOffset * limit;

      getAllInstitutions({
        offset,
        orderBy: orderBy || '',
        search: searchStorage || '',
        dir: directionAsc,
      });
    },
    [directionAsc, setPageCurrent]
  );

  const filterInstitution = useCallback(async ({ search }) => {
    dispath(
      actions.getInstitutionsRequest({
        orderBy: instituitionsOrderBy || '',
        search,
      })
    );
  }, []);

  const formik = useFormik({
    initialValues: {
      search: searchStorage || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      search: VALIDATIONS.requiredString,
    }),
    onSubmit: async ({ search }) => {
      sessionStorage.setItem('searchInstituition', search);
      filterInstitution({ search });
    },
  });

  useEffect(() => {
    // Limpa instituição selecionada
    dispath(
      actions.getInstitutionSuccess({
        instituitionData: null,
      })
    );

    // Get Insituições
    getAllInstitutions();
  }, []);

  return (
    <>
      <Breadcumbs
        path="instituicoes-participantes"
        pathTitle="Instituições participantes"
      />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <span>Instituições participantes </span>

          <div className="boxSearch">
            <form onSubmit={formik.handleSubmit} method="post">
              <label htmlFor="search">
                <MdSearch size={18} color="#619b30" />
                <input
                  name="search"
                  id="search"
                  placeholder="Buscar instituição"
                  value={formik.values.search}
                  onChange={formik.handleChange}
                />
              </label>{' '}
              <ButtonBase type="submit">Buscar</ButtonBase>
              <ButtonBase
                variant="secondary"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  sessionStorage.removeItem('searchInstituition');
                  getAllInstitutions({ search: null, orderBy: null });
                }}
              >
                Limpar
              </ButtonBase>
            </form>
          </div>
        </div>

        <div className="addNew">
          <Link to="/administrador/adicionar-nova-instituicao">
            <ButtonBase type="button">
              <>
                <GoPlus /> Adicionar nova
              </>
            </ButtonBase>
          </Link>
        </div>
      </PageTitle>

      {data.length > 0 ? (
        <BoxContent>
          <BoxContentHeader>
            <div>
              <ButtonOrderBy
                isActive={instituitionsOrderBy === 'cnes'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getAllInstitutions({ orderBy: 'cnes', dir: !directionAsc });
                }}
              >
                <span className="cnesHeader">
                  CNES{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={instituitionsOrderBy === 'nomeFantasia'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getAllInstitutions({
                    orderBy: 'nomeFantasia',
                    dir: !directionAsc,
                  });
                }}
              >
                <span>
                  Instituição{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
          </BoxContentHeader>

          {data.map(
            ({
              id,
              cnes,
              nomeFantasia,
              solicitacaoReabertura,
              ativo,
              jaEnviouAlgumPerfil,
            }) => {
              const linkPerfil = `/administrador/perfil-do-hospital/${id}`;

              const linkEditar = `/administrador/instituicao/${id}`;
              const linkIndicadores = `/administrador/indicadores/${id}`;

              return (
                <BoxList
                  key={cnes}
                  solicitacaoReabertura={solicitacaoReabertura}
                  ativo={ativo}
                >
                  <div className="cnes">
                    <span>{cnes}</span>
                  </div>
                  <div className="name">
                    <p>{nomeFantasia}</p>
                  </div>
                  <div className="buttons">
                    <button type="button">
                      <Link
                        to={{
                          pathname: linkIndicadores,
                          state: { id },
                        }}
                      >
                        <img src={iconCharts} alt="Indicadores" />
                        <span>Indicadores</span>
                      </Link>
                    </button>

                    <button
                      type="button"
                      disabled={!jaEnviouAlgumPerfil}
                      onClick={() =>
                        jaEnviouAlgumPerfil
                          ? history.push({
                              pathname: linkPerfil,
                              state: { id },
                            })
                          : null
                      }
                    >
                      <img
                        src={iconProfileInstitutions}
                        alt="Perfil da Instituição"
                      />
                      <span>Perfil da Instituição</span>
                    </button>

                    <button type="button">
                      <Link to={linkEditar}>
                        <MdModeEdit size={18} />
                        <span>Dados cadastrais</span>
                      </Link>
                    </button>
                  </div>
                </BoxList>
              );
            }
          )}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default InstituicoesParticipantes;
